<div [ngClass]="{'suggest-item': !borderBottom}">
  <p class="lead mb-0"><strong>{{viewModel?.offerName}}</strong></p>
  <p class="mb-0">{{viewModel?.detail}}</p>
  <div class="btn-center">
    <a
      class="btn btn-secondary my-1"
      data-e2e="add-suggested"
      [href]="getAddSuggestedContractLink() | link: ParamsUtils.cidMap(viewModel.cid) | async"
      (click)="addSuggestContract();false"
    >
      {{"dashboard.contractsAndOptions.suggestedContract.addContract.button" | translate}}
    </a>
  </div>
  <div class="btn-center">
    <a
      class="o-link-arrow mt-1 mt-md-0"
      data-e2e="remove-suggested"
      [ngClass]="borderBottom ? 'mb-2' : 'mb-1'"
      [href]='"dashboard.contractsAndOptions.suggestedContract.removeContract.link" | translate | link: ParamsUtils.cidMap(viewModel.cid) | async'
      (click)="removeSuggestedContract();false"
    >
      {{"dashboard.contractsAndOptions.suggestedContract.removeContract.button" | translate}}
    </a>
  </div>
</div>
